@if (showInfoBar && headerLinks?.length) {
  <div class="info">
    <div class="info-wrapper">
      @for (link of headerLinks; track $index) {
        @if (sameSite(link); as link) {
          <a class="nav" [routerLink]="link.targetUrl" [target]="link.new ? '_blank' : '_self'">
            {{ link.titleText }}
          </a>
        }
        @if (!sameSite(link)) {
          <a class="nav" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'">{{ link.titleText }}</a>
        }
      }
      @if (enableMembers) {
        <app-member-bar></app-member-bar>
      }
    </div>
  </div>
}
@if (enableMembers && (!showInfoBar || !headerLinks?.length)) {
  <app-member-bar></app-member-bar>
}
<header>
  @if (showShipping && !showOnlyLogo) {
    @if (!storeClosed) {
      <div class="shipping" [class.kiosk]="isKiosk">
        <app-icon-button [icon]="shippingIcon" id="menu" (click)="openMenu()">Menu</app-icon-button>
        <label for="menu" (click)="openMenu()">{{ menuLabel }}</label>
      </div>
    }
    <div class="shipping mobileMenu" [class.kiosk]="isKiosk">
      <app-icon-button [icon]="mobileMenuIcon" (click)="openMobileMenu()">Menu</app-icon-button>
    </div>
  }
  <a routerLink="/" class="logo-container">
    <img [ngSrc]="storeLogo.src" width="320" height="140" [alt]="storeLogo.alt" priority />
  </a>
  @if (showBasket && !showOnlyLogo) {
    <div class="basket">
      <div class="basket-label">
        <label for="price">{{ basketLabel }}</label>
        @let loading = isLoading$ | async;
        @if (!loading) {
          <span id="price" class="basket-price"> {{ price$ | async | number: '.2-2' : locale }} {{ currency | displayCurrency }} </span>
        }
        @if (loading) {
          <div class="loading">
            <img src="assets/preloader.gif" alt="loading price" />
          </div>
        }
      </div>
      <app-icon-button [icon]="basketIcon" (click)="openBasket()" [matBadge]="count$ | async">{{ basketLabel }}</app-icon-button>
    </div>
  }
</header>
